<template>
    <NuxtLink
        v-if="to"
        :to
        class="base-label"
        :style="`mask-image: url(/marker-strokes/${marker}.svg);`"
    >
        {{ label }}
    </NuxtLink>
    <component
        :is="element"
        v-else
        class="base-label"
        :style="`mask-image: url(/marker-strokes/${marker}.svg);`"
    >
        {{ label }}
    </component>
</template>

<script setup>
defineProps({
    element: {
        type: String,
        default: 'div'
    },
    to: {
        type: String,
        default: ''
    },
    marker: {
        type: String,
        default: '4',
        validator: value => !!value
    },
    label: {
        type: String,
        default: ''
    }
});
</script>

<style lang="less" src="./BaseLabel.less" />
